import React from 'react';
import { UIPreviewComp } from '../../project/dev/UIPreviewComp';

export default class ModifyUserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <UIPreviewComp guid="gw_UI_user_0001"
                transferData={{
                    "@userId": tool.getCookie("id"),
                    "@module": this
                }} />
        );
    }
}


// WEBPACK FOOTER //
// ./apps/pages/main/ModifyUserInfo.js